import AbstractView from 'abstracts/AbstractView';
import Screen from "controllers/Screen";
import Scroll from "controllers/Scroll";
import Main from "controllers/Main";
import Device from "controllers/Device";
import Math_ from "utils/Math";
import FooterEmail from "./FooterEmail";


export default class Footer extends AbstractView {
	
	
	constructor( $wrapper ) {
		super();
		this.$footer      = $wrapper;
		this.dezoom       = false;
		this.footerHeight = 0;
		this.init();
	}
	
	
	initDOM() {
		this.$header  = $( "#header" );
		this.$content = this.$footer.closest( '.page_content' ).find( '.page_content-inner' );
		
		this.$emails = this.$footer.find( '.footer-contact_email' )
	}
	
	
	initEl() {
		Array.from( this.$emails ).forEach(
			email => {
				new FooterEmail( email );
			}
		)
	}
	
	
	bindEvents() {
		if ( !Device.IS_TOUCH ) {
			Screen.on( Screen.E.RESIZE, this.resize, this );
			Main.on( Main.E.RAF, this.raf, this );
			this.refreshHandler = this.updateBodyHeight.bind( this );
			ScrollTrigger.addEventListener( 'refresh', this.refreshHandler );
		}
		
	}
	
	
	unbindEvents() {
		if ( !Device.IS_TOUCH ) {
			Screen.off( Screen.E.RESIZE, this.resize, this );
			Main.off( Main.E.RAF, this.raf, this );
			ScrollTrigger.removeEventListener( 'refresh', this.refreshHandler );
		}
		super.unbindEvents();
	}
	
	
	updateBodyHeight() {
		if ( Scroll.smooth ) {
			this.bodyHeight = Scroll.smooth.scrollTrigger.end;
		}
	}
	
	
	resize() {
		// Get footer height
		this.footerHeight = this.$footer.outerHeight( true );
		document.documentElement.style.setProperty( '--footer-height', this.footerHeight + 'px' );
		
		// Reset dezoom
		this.dezoom = false;
		document.documentElement.style.removeProperty( '--footer-scale' );
		
		// Update the scroll
		Scroll.resize();
		
	}
	
	
	raf() {
		if ( Scroll.yI > ( this.bodyHeight - this.footerHeight ) ) {
			if ( this.dezoom === false ) {
				this.dezoom = true;
				// this.$header.addClass('force-hidden');
			}
			const yPercent     = Math_.clamp( ( ( this.bodyHeight - Scroll.yI ) / ( this.footerHeight ) ), 0, 1 ),
				  scalePercent = Math_.clamp( ( ( this.bodyHeight - Scroll.yI - this.footerHeight * 0.75 ) / ( this.footerHeight * 0.25 ) ), 0, 1 ),
				  // 1 to 0.95
				  scaleValue   = 1 - ( 0.05 * ( 1 - scalePercent ) );
			document.documentElement.style.setProperty( '--footer-scale', scaleValue );
			gsap.set( this.$footer, {
				y: yPercent * -( this.footerHeight * 0.75 )
			} )
		} else {
			if ( this.dezoom === true ) {
				this.dezoom = false;
				// this.$header.removeClass('force-hidden');
				document.documentElement.style.removeProperty( '--footer-scale' );
				gsap.to( this.$footer, {
					duration: 0.3,
					y:        -( this.footerHeight * 0.75 )
				} );
			}
		}
	}
	
	
	destroy() {
		super.destroy();
		document.documentElement.style.removeProperty( '--footer-height' );
		document.documentElement.style.removeProperty( '--footer-scale' );
	}
}
